import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.oms')
  .factory('$omsOrdersMessages', omsOrdersMessagesObjectFactory);

/* @ngInject */
function omsOrdersMessagesObjectFactory($bringozFactory: $bringozFactory,
                                        OmsOrdersMessagesAPI: BringozApi,
                                        Oms_Orders_Messages_DS: DataStoreConfig) {

  function $omsOrdersMessages(id: string) {
    return $bringozFactory(id, OmsOrdersMessagesAPI, Oms_Orders_Messages_DS)
  }
  return $omsOrdersMessages
}
